var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkFilled = function SvgLinkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 8a4 4 0 1 0 0 8h2a1 1 0 1 1 0 2H7A6 6 0 0 1 7 6h2a1 1 0 0 1 0 2zM14 7a1 1 0 0 1 1-1h2a6 6 0 0 1 0 12h-2a1 1 0 1 1 0-2h2a4 4 0 0 0 0-8h-2a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgLinkFilled;